/******************************************************
 *                  Client Ctrl
 ********************************************************/

"use strict";

angular.module("exploitation")

	.controller("AdminClientsEditCtrl", [ "$scope", "client", "$uibModal", "mode", "AdminClientsService",  "Utils", "toastr", "$location",  "schemas", "$controller", "$timeout", "$window", function ($scope, client, $uibModal, mode, AdminClientsService,  Utils, toastr, $location,  schemas, $controller) {


		$controller("AdminClientsCtrlParent", {$scope: $scope});

		var confirmResetWhiteListModal;
		
		/******************************************************
			 *                  SETUP
			 ********************************************************/
		$scope.data = {
			client: client.data,
			reports: {},
			schemas: schemas.data,
			mode: mode,
			status: {
				isThirdOpen: true,
				isSecondOpen: true,
				isFirstOpen: true,
				isFirstDisabled: false,
				isFourthOpen: false,
				isFifthOpen: false
			},
			pegase: {},
			isTopologyActivated: true,
			areDisruptionsActivated: false
		};

		if ($scope.data.mode === 'add') {
			$scope.data.client = {
				type: 'COMPANY',
				nbNetworksAllowed :10,
				idfm: false
			};
		}

		if ($scope.data.client !== null && $scope.data.client.id !== undefined){
			AdminClientsService.getClientModuleAccessibilitites($scope.data.client.id)
				.then((response) => {
					let data = response.data;

					$scope.data.isTopologyActivated = data.is_topology_activated;

					if (data.are_disruptions_activated){
						$scope.data.areDisruptionsActivated = true;
					}
				});
		}

		/******************
			 * SCOPE FUNCTIONS
			 ******************/

		$scope.openConfirmResetWhiteListModal = function (client) {
			confirmResetWhiteListModal = Utils.openModal($uibModal, "confirmResetWhiteListModal.html", $scope);
		};


		/**
			 * Ajouter un rapport dans la liste des rapports du client.
			 * @param report
			 */
		$scope.addReportToClient = function (report) {
			if (($scope.data.client.reports.filter(function (clientReport) {
				return clientReport.id === report.id;
			})).length == 0) {
				$scope.data.client.reports.push(report);
			}
		};


		/**
			 * Supprimer un rapport de la liste des rapports du client.
			 * @param report
			 */
		$scope.removeReportFromClient = function (report) {
			var position = -1;
			$scope.data.client.reports.forEach(function (clientReport, index) {
				if (clientReport.id === report.id) {
					position = index;
				}
			});
			if (position != -1) {
				$scope.data.client.reports.splice(position, 1);
			}
		};


		/**
			 * Créer le label pour les options du select permettant d'ajouter un rapport au client.
			 * @param report
			 * @returns {string}
			 */
		$scope.composeLabel = function (report) {
			return report.name + " -  " + report.filename;
		};


		/**
			 * Poster ou éditer une ressources
			 */
		$scope.edit = function () {
			if ($scope.data.mode === "add") {
				$scope.data.client.code = $scope.buildSchemaName($scope.data.client.name);
				$scope.data.client.schemaName = $scope.data.client.code;
				$scope.data.client.codeIdfm = $scope.data.client.code;

				AdminClientsService.addClient($scope.data.client).then(() => {
					AdminClientsService.refreshUserClients();
					AdminClientsService.editModuleAccessibilities($scope.data.client, $scope.data.isTopologyActivated, $scope.data.areDisruptionsActivated);
					toastr.success("", "Organisation créée");
					$location.path("/admin/filiales");
				}).catch((response) => {
					const data = response.data;
					let errorMessage = "Problème lors de la création de l'organisation. ";
					if (data !== undefined && data.message) {
						errorMessage += data.message;
					}
					toastr.error(errorMessage, "Erreur");
				});
			} else if ($scope.data.mode === "edit") {
				AdminClientsService.editClient($scope.data.client).then((response) => {
					const data = response.data;
					AdminClientsService.editModuleAccessibilities($scope.data.client, $scope.data.isTopologyActivated, $scope.data.areDisruptionsActivated);
					toastr.success("", "Organisation " + data.code + " mise à jour");
					AdminClientsService.refreshUserClients();
					$location.path("/admin/filiales");
				}).catch((response) => {
					const data = response.data;
					let errorMessage = "Problème lors de la mise à jour de l'organisation. ";
					if (data !== undefined && data.message) {
						errorMessage += data.message;
					}
					toastr.error(errorMessage, "Erreur");
				});
			}
		};


		/**
			 * Relancer la liste blanche
			 */
		$scope.startResetWhiteList = function () {
			AdminClientsService.startResetWhiteList($scope.data.client.id)
				.then(() => {
					toastr.success("", "Reset liste blanche");
					confirmResetWhiteListModal.close();
				}).catch((response) => {
					const data = response.data;
					let errorMessage = "Problème reset liste blanche.";
					if (data !== undefined && data.message) {
						errorMessage += data.message;
					}
					toastr.error(errorMessage, "Erreur");
				});
		};

		$scope.onNameChange = function() {
			const name = $scope.data.client.name;
			$scope.buildSchemaName(name);
		};

		/*****IMPORT PEGASE***/

		$scope.error = undefined;


			$scope.invalidCharacterError = false;

			$scope.buildSchemaName = function(str) {
				const patterns = [
					{ pattern: /[-_ ]/g, replacement: '_' },
					{ pattern: /[áàãâÀÁÃÂ]/g, replacement: 'a' },
					{ pattern: /[éèêÉÈÊ]/g, replacement: 'e' },
					{ pattern: /[íìîÍÌÎ]/g, replacement: 'i' },
					{ pattern: /[óòôõÓÒÔÕ]/g, replacement: 'o' },
					{ pattern: /[úùûüÚÙÛÜ]/g, replacement: 'u' },
					{ pattern: /[çÇ]/g, replacement: 'c' },
					{ pattern: /[ñÑ]/g, replacement: 'n' },
					{ pattern: /[&]/g, replacement: '' }
				];

				// Vérification pour les caractères non autorisés
				const authorizedCharactersPattern = /^[a-z0-9ñç_]*$/i;
				// Préparation de la chaîne pour la vérification
				let verificationStr = str.toLowerCase();
				patterns.forEach(({ pattern, replacement }) => {
					verificationStr = verificationStr.replace(pattern, '');
				});

				// Si la chaîne nettoyée ne correspond pas au motif de caractères autorisés
				if (!authorizedCharactersPattern.test(verificationStr)) {
					$scope.invalidCharacterError = true;
					return ""; // Retourne une chaîne vide ou gère l'erreur comme souhaité
				} else {
					$scope.invalidCharacterError = false; // Réinitialisez le message d'erreur si tout est correct
				}

				// Applique les motifs de remplacement si la chaîne est valide
				patterns.forEach(({ pattern, replacement }) => {
					str = str.replace(pattern, replacement);
				});

				return str.toLowerCase();
			};

		}]
	)
;
